<template>
    <div class="ks-footer" :class="`ks-footer-${$route.params.route || $route.name}`">
        <div class="ks-footer-top">
          <div class="adresse">
            <span>Kulturstiftung des Kantons Thurgau</span>
            <span>Lindenstrasse 12, 8500 Frauenfeld</span>
            <span><span class="indent">Telefon</span>+41 52 202 29 19</span>
            <span><span class="indent">Email</span><a href="mailto:info@kulturstiftung.ch">info@kulturstiftung.ch</a></span>
            <span><span class="indent">Follow us</span><a href="//www.instagram.com/kulturstiftung.thurgau/" target="_blank">Instagram</a>, <a href="//www.facebook.com/kulturstiftungthurgau" target="_blank">Facebook</a></span>
          </div>
          <div class="logo" :style="{'font-family': $root.latestFont}">K</div>
          <div class="anmeldung" v-if="mailresponse.Form">
            <span v-if="mailresponse.Message && mailresponse.Message=='link_error'">Der Bestätigungslink ist ungültig</span>
            <span v-else>Registrierung für den Newsletter:</span>
            <form v-on:submit.prevent="subscribe()">
              <span>
                <span class="indent">E-Mail</span>
                <input type="email" placeholder="ich@me.com" v-model="newsletter.email">
              </span>
              <span>
                <span class="indent">Abschicken</span>
                <input type="submit" value=" ">
              </span>
            </form>
            <span>&nbsp;</span>
            <span>2022 Kulturstiftung Thurgau.</span>
          </div>
          <div class="anmeldung" v-else>
            <span v-if="mailresponse.Message=='confirmed'">Ihre E-Mailadresse ist bestätigt. Vielen Dank</span>
            <span v-else-if="mailresponse.Message=='sent'">Wir haben eine E-Mail mit einem Bestätigungslink geschickt.</span>
            <span v-else>{{mailresponse.Message}}</span>
            <span>&nbsp;</span>
            <span>&nbsp;</span>
            <span>&nbsp;</span>
            <span>2022 Kulturstiftung Thurgau.</span>
          </div>
        </div>
    </div>
</template>

<script>

/* eslint-disable */

export default {
  name: 'Footer',
  data() {
    return({
      newsletter: {
        email: ""
      },
      mailresponse: {
        Error: "",
        Message: "",
        Form: true
      }
    });
  },
  methods: {
      async subscribe() {
        let response = await this.$http.post('/newsletter', this.newsletter);
        this.mailresponse = response.data;
    }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
    
@import '../main';

.ks-footer {
  background: #000;
  height: $sticky-height;
  color: #FFF;
  z-index: 4;
  position: relative;
  padding-left: var(--pd1);
  padding-right: var(--pd1);

  &-top {
    height: $sticky-height;
    margin: auto;
    max-width: $wide-container;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
  }
  .logo {
      padding-top: 0.75rem;
      font-size: calc(#{$sticky-height} - 3rem);
      width: 10%;
      text-align: center;
      flex-grow: 30;
  }
  .adresse,
  .anmeldung {
    @include smallfont();
    flex-shrink: 3;
    width: 400px;
    overflow: hidden;
    & > form > span,
    & > span {
      border-bottom: 1px solid;
      padding-right: var(--pd2);
      display: block;
      line-height: 25px;
      white-space: nowrap;
      & > .indent {
        min-width: 6rem;
        display: inline-block;
      }
    }
    & > span:first-child {
      border-top: 1px solid;
    }
    & > form > span {
      padding-right: 0;
      width: 100%;
      overflow: hidden;
    }
  }
  .anmeldung {
    color: #FF0;   
    input {
      display: inline-block;
      width: 0px;
      appearance: none;
      border: none;
      font: inherit;
      background: transparent;
      color: black;
      padding: 0 0.75rem;
      margin: 0;
      height: auto;
      position: relative;
      display: inline-block;
      background: #FF0;
      border-radius: var(--pd1);
      height: 23px;
      line-height: 20px;
      transition: all 0.25s;
      &[type="email"] {
        top: 3px;
        &:focus {
          width:  calc(100% - 8rem);
        }
        &::placeholder {
          color: inherit;
          line-height: 20px;
        }
      }        
      &[type="submit"] {
        width: auto;
        padding: 0 0.5rem;
        cursor: pointer;
        border: 1px solid transparent;
        &:active {
          border-color: #FF0;
          background: black !important;
        }
      }
      &:focus {
        outline: none;
      }
    }
  }
  @include sd() {
    .adresse,
    .anmeldung {
      width: 340px;
      & > form > span,
      & > span {
        & > .indent {
          min-width: auto;
        }
      }
    }
    .anmeldung {
      input {
        &[type="email"] {
          &:focus {
            width:  calc(100% - 5.5rem);
          }
        }
      }
    }
  }
  @include st() {
    .anmeldung {
      input {
        &[type="email"] {
          &:focus {
            width:  calc(100% - 10rem);
          }
        }
      }
    }      
    height: auto;
    padding-top: var(--pd1);
    padding-bottom: var(--pd1);
    &-top {
      flex-wrap: wrap;
      height: auto;
    }
    .logo,
    .adresse,
    .anmeldung {
      width: 100%;
      & > form > span,
      & > span {
        & > .indent {
          min-width: 6rem;
        }
      }        
    }
  }
  @include sm() {
    .adresse,
    .anmeldung {
      input {
        width: 0px !important;
        padding: 0 10px !important;
        border-radius: 10px !important;
        height: 20px;
        line-height: 10px;
        top: 0.5px !important;
        border: none !important;
        &:focus {
          width:  calc(100% - 13rem) !important;
        }
      }
    }
  }    
  &-projekte {
    .logo,
    .adresse,
    .anmeldung {
      color: $ks-pink;
    }
    .anmeldung input {
      border-color: $ks-pink;
    }
    input {
      background: $ks-pink !important;
      &[type="submit"]:active {
          border-color: $ks-pink !important;
      }
    }
  }
  &-stiftung {
    .logo,
    .adresse,
    .anmeldung {
      color: $ks-green;
    }
    .anmeldung input {
      border-color: $ks-green;
    }
    input {
      background: $ks-green !important;
      &[type="submit"]:active {
          border-color: $ks-green !important;
      }
    }                    
  }        
  &-new,
  &-news,
  &-calls {
    .logo,
    .adresse,
    .anmeldung {
      color: $ks-blue;
    }
    .anmeldung input {
      border-color: $ks-blue;
    }
    input {
      background: $ks-blue !important;
      &[type="submit"]:active {
          border-color: $ks-blue !important;
      }
    }
  }
  &-gesuche {
    .logo,
    .adresse,
    .anmeldung {
      color: $ks-yellow;
    }
    .anmeldung input {
      border-color: $ks-yellow;
    }
    input {
      background: $ks-yellow !important;
      &[type="submit"]:active {
          border-color: $ks-yellow !important;
      }
    }          
  }
  &-kontakt {
    .logo,
    .adresse,
    .anmeldung {
      color: $ks-grey-medium;
    }
    .anmeldung input {
      border-color: $ks-grey-medium;
    }
    input {
      background: $ks-grey-medium !important;
      &[type="submit"]:active {
          border-color: $ks-grey-medium !important;
      }
    }
  }
}
</style>



      


// WEBPACK FOOTER //
// src/components/Footer.vue